import React, {Component} from 'react';
import './Cours.css';

class Article extends Component {

    render() {
        return (

            <div id="cours" className="row home-block">

                <div>
                    <h2 className="title">Cours</h2>
					<p> La plupart de mes documents pédagogiques sont rendus disponibles sur l'environnement numérique de travail Moodle de l'université ou l'école.
Voici toutefois quelques documents, notes de cours, exercices, sujets et autres documents relatifs à différents enseignements ou formations effectués ces dernières années
					</p>

					<ul>
						<li><a href="/cours-estimation-2019">Estimation - Analyse de données, M1 E.S.I.E.A. 2019-2020 </a> </li>
						<li> <a href="/cours-estimation-2018">Estimation - Analyse de données, M1 E.S.I.E.A. 2018-2020</a> </li>
						<li> <a href="/cours-analyse-exploratoire-2018">Analyse exploratoire, M2 E.S.I.E.A. 2018-2020</a> </li>
						<li> <a href="/cours-modeles-pour-la-datascience-2018">Modèles pour la data science, M2 E.S.I.E.A. 2018-2020 </a>  </li>
						<li> <a href="/cours-base-de-donnees-2019">Base de données, M1 Statistiques, Univ. de Strasbourg 2018-2019</a> </li>
					</ul>
                </div>
            </div>
        );
    }
}

export default Article;



// WEBPACK FOOTER //
// ./src/Components/Cours/Cours.js